import { Link } from 'react-router-dom'
import { Separator } from '@/components/ui/separator'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-card/80 backdrop-blur-sm border-t border-border/50 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <Link 
              to="/impressum" 
              className="hover:text-primary transition-colors"
            >
              Impressum
            </Link>
            <Separator orientation="vertical" className="h-4" />
            <Link 
              to="/datenschutz" 
              className="hover:text-primary transition-colors"
            >
              Datenschutzerklärung
            </Link>
          </div>
          
          <div className="text-sm text-muted-foreground">
            © {currentYear} Herzensempfehlung.de - made by Maximilian Schüller
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer